/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx } from '@compiled/react';

import type { SuggestionItemResponse } from '@atlassian/navigation-bff-data-provider';

import { LOOM_ATI } from '../../../constants';
import type { SourceProduct, SuggestionConfigContext } from '../../../types';

import { LoomVideoItem } from './primitives/LoomItem/LoomVideoItem';
import { SuggestionItemBase } from './SuggestionItemBase';

export interface SuggestionItemProps {
	/**
	 * The response item from Universal Create
	 */
	responseItem: SuggestionItemResponse;

	/**
	 * Additional context for the component
	 */
	context?: SuggestionConfigContext;

	/**
	 * The source product context
	 */
	product: SourceProduct;
}

/**
 * SuggestionMenuContentItem component that renders a suggestion item in the Universal Create interface.
 * Returns LoomVideoMenuItem for Loom ATIs, otherwise returns GenericMenuItem.
 */
export function SuggestionItem({ responseItem, context, product }: SuggestionItemProps) {
	const isLoomAti = responseItem.ati === LOOM_ATI;

	if (isLoomAti && context) {
		return <LoomVideoItem responseItem={responseItem} context={context} product={product} />;
	}

	// Return GenericMenuItem with no customisedItemConfig for non-Loom ATIs
	return <SuggestionItemBase responseItem={responseItem} />;
}
